Vue.component('update-profile-details', {
    props: ['user'],

    data() {
        return {
            form: new SparkForm({
                name: '',
                first_name: '',
                last_name: '',
                email: '',

                occupation: '',
                company: '',
                phone: '',
                mobile: '',

                billing_street: '',
                billing_address_line_2: '',
                billing_city: '',
                billing_state: '',
                billing_zip: '',
                billing_country: '',

                skype: '',
                twitter: '',
                instagram: '',
                facebook: '',
                linkedin: '',
                google: ''
            })
        };
    },

    mounted() {
        this.form.name = this.user.name;
        this.form.first_name = this.user.first_name;
        this.form.last_name = this.user.last_name;
        this.form.email = this.user.email;
        this.form.occupation = this.user.occupation;
        this.form.company = this.user.company;
        this.form.phone = this.user.phone;
        this.form.mobile = this.user.mobile;

        this.form.billing_address = this.user.billing_address;
        this.form.billing_address_line_2 = this.user.billing_address_line_2;
        this.form.billing_city = this.user.billing_city;
        this.form.billing_state = this.user.billing_state;
        this.form.billing_zip = this.user.billing_zip;
        this.form.billing_country = this.user.billing_country;

        this.form.skype = this.user.skype;
        this.form.linkedin = this.user.linkedin;
        this.form.facebook = this.user.facebook;
        this.form.twitter = this.user.twitter;
        this.form.instagram = this.user.instagram;
        this.form.google = this.user.google;

        this.form.current_profile_status = this.user.status;
    },

    methods: {
        update() {
            Spark.put('/settings/profile/details', this.form)
                .then(response => {
                Bus.$emit('updateUser');
        });
            eswal("Updated User Profile");

            if(this.user.status == 'profile_incomplete') {
                window.location.href = '/home';
            }
        }
    }
});